import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { ChevronsUpDown, UserMinus } from "lucide-react";

export default function AssignPicker({ staff, value = [], onChange, testid }) {
  const ids = [value].flat(Infinity).filter((x) => typeof x === "string" && x);
  const names = staff.filter((s) => ids.includes(s.id)).map((s) => s.name);
  const toggle = (id) => onChange(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testid} className="mt-1 h-9 w-full justify-between font-normal px-3">
          <span className={`truncate ${names.length ? "" : "text-muted-foreground"}`}>{names.length ? names.join(", ") : "Unassigned"}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-1" align="start">
        <button type="button" onClick={() => onChange([])} disabled={!ids.length} data-testid={`${testid}-unassign`}
          className="w-full flex items-center gap-2 px-2 py-2 rounded text-sm font-semibold text-red-400 hover:bg-accent disabled:opacity-40 transition-colors">
          <UserMinus className="w-4 h-4" />Unassigned (remove everyone)
        </button>
        <div className="max-h-64 overflow-y-auto border-t border-border mt-1 pt-1">
          {staff.map((s) => (
            <label key={s.id} className="flex items-center gap-2 px-2 py-1.5 rounded text-sm cursor-pointer hover:bg-accent" data-testid={`${testid}-opt-${s.id}`}>
              <Checkbox checked={ids.includes(s.id)} onCheckedChange={() => toggle(s.id)} />{s.name}
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
